export default __webpack_public_path__ + "static/media/88429B69-6FD5-4C1F-8672-9196763576B9.881ab146.jpg";